import {
  ChangeEvent,
  KeyboardEvent,
  useCallback,
  useMemo,
  useState,
} from "react";
import Fuse, { IFuseOptions } from "fuse.js";

export const useFuseSearch = <T,>({
  list,
  options,
  isEnabled = true,
}: {
  list: T[];
  options: IFuseOptions<T>;
  isEnabled?: boolean;
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const fuse = useMemo(() => {
    const fuseOptions = {
      threshold: 0.25,
      shouldSort: false,
      ...options,
    };
    return new Fuse(list, fuseOptions);
  }, [list, options]);

  const results = useMemo(() => {
    return isEnabled && searchTerm.length > 0
      ? fuse.search(searchTerm)
      : undefined;
  }, [fuse, searchTerm, isEnabled]);

  const onSearch = useCallback(
    (
      eventOrValue:
        | ChangeEvent<HTMLInputElement>
        | KeyboardEvent<HTMLInputElement>
        | string,
    ) => {
      if (typeof eventOrValue === "string") {
        setSearchTerm(eventOrValue.trim());
      } else {
        const target = eventOrValue.target as HTMLInputElement;
        setSearchTerm(target.value.trim());
      }
    },
    [setSearchTerm],
  );

  return { results, onSearch };
};
